export default "__VITE_ASSET__CBjmNhNv__"